// extracted by mini-css-extract-plugin
module.exports =  {"review":"_7a3fb80146--review--gUEHP","review--link":"_7a3fb80146--review--link--JH8uY","review--link--rating":"_7a3fb80146--review--link--rating--etc1f"};